import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // isAuthenticated è un signal: si legge come funzione
  if (auth.isAuthenticated()) return true;

  router.navigate(['/login']);
  return false;
};
